import request from '@/router/axios';

const getList = (current, size, params) => request({
  url: '/api/mcc-staff/updatelog/page',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

const getListGroupByStaff = params => request({
  url: '/api/mcc-staff/updatelog/updateLogMap',
  method: 'get',
  params: {
    ...params,
  },
})
const getListGroupByStaffNew = params => request({
  url: '/api/mcc-staff/updatelog/search',
  method: 'get',
  params: {
    ...params,
  },
})
const getListGroupByStaffDetailNew = params => request({
  url: '/api/mcc-staff/updatelog/searchDetail',
  method: 'get',
  params: {
    ...params,
  },
})
const add = params => request({
  url: '/api/mcc-staff/updatelog/save',
  method: 'post',
  data: params,
})

const detail = params => request({
  url: '/api/mcc-staff/updatelog/detail',
  method: 'get',
  params: {
    ...params,
  },
})

const update = params => request({
  url: '/api/mcc-staff/updatelog/update',
  method: 'post',
  data: params,
})

const adoptUpdate = params => request({
  url: '/api/mcc-staff/updatelog/adoptUpdate',
  method: 'post',
  params,
})

const failUpdate = params => request({
  url: '/api/mcc-staff/updatelog/failUpdate',
  method: 'post',
  params,
})

const remove = ids => request({
  url: '/api/mcc-staff/updatelog/remove',
  method: 'post',
  params: {
    ids,
  },
})

export default {
  getList,
  add,
  detail,
  update,
  remove,
  getListGroupByStaff,
  getListGroupByStaffNew,
  getListGroupByStaffDetailNew,
  adoptUpdate,
  failUpdate,
};
